export enum EmailStatus {
  PENDING = 0,
  SENDING = 1,
  SENT = 2,
  OPENED = 3,
  FAILED = 4
}



// WEBPACK FOOTER //
// ./src/models/portfolioadmin/reportManagement/emailStatus.ts